/* eslint-disable max-len */
// Copyright (c) 2022 Celadon Development LLC, All rights reserved.
// Author Alexander Mikholap <alexander.miholap@celadon.ae>
import React from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';

import {
  Loader
} from '../../../components';
import {
  VoucherAmount,
  BookshopCustomerForm
} from '../components';

import {
  getTotal
} from '../../basket/store/selectors';
import {
  getLoading,
  getBookshopCustomer,
  getRequestStatus,
} from '../store/selectors';
import * as issueVoucherActions from '../store/actions';

import history from '../../../services/history';
import styles from './styles';


class IssueVoucherPage extends React.Component {
  state = { };

  componentDidMount() {
    const { total, resetBookshopCustomerForm } = this.props;

    if (total.redeemValue === 0) {
      history.push('/basket');
    }

    resetBookshopCustomerForm();
  }

  render() {
    const {
      classes,
      total,
      loading,
      bookshopCustomer,
      requestStatus,
      changeCustomerFields,
      issueVoucher,
    } = this.props;

    // No PaperLayout here: this screen is mounted inside the account shell so
    // the shop keeps its navigation tabs, and that shell already supplies the
    // page chrome. Wrapping it again would nest <Navigation> twice.
    return (
      <div>
        <h4 className={classes.screenTitle}>ISSUE VOUCHER</h4>
        <div className={classes.container}>
          { loading
            ? <Loader />
            : (
              <div>
                <VoucherAmount redeemValue={total.redeemValue} />
                <div className={classes.descContainer}>
                  <p className={classes.desc}>Please fill in the customer details</p>
                  <p className={classes.desc}>Below to issue gift voucher</p>
                </div>
                <BookshopCustomerForm
                  bookshopCustomer={bookshopCustomer}
                  requestStatus={requestStatus}
                  changeCustomerFields={changeCustomerFields}
                  issueVoucher={issueVoucher}
                />
              </div>
            )
          }
        </div>
      </div>
    );
  }
}

IssueVoucherPage.propTypes = {
  classes: PropTypes.object,
  loading: PropTypes.bool,
  total: PropTypes.object,
  bookshopCustomer: PropTypes.object,
  requestStatus: PropTypes.object,

  changeCustomerFields: PropTypes.func,
  resetBookshopCustomerForm: PropTypes.func,
  issueVoucher: PropTypes.func,
};

IssueVoucherPage.defaultProps = {
  classes: {},
  total: {},
  loading: false,
  bookshopCustomer: {},
  requestStatus: {},

  changeCustomerFields: () => { },
  resetBookshopCustomerForm: () => { },
  issueVoucher: () => { },
};

const mapStateToProps = (state) => {
  return {
    loading: getLoading(state),
    total: getTotal(state),
    bookshopCustomer: getBookshopCustomer(state),
    requestStatus: getRequestStatus(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    changeCustomerFields: (value, field) => dispatch(issueVoucherActions.changeCustomerFields(value, field)),
    resetBookshopCustomerForm: () => dispatch(issueVoucherActions.resetBookshopCustomerForm()),
    issueVoucher: () => dispatch(issueVoucherActions.issueVoucher()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(IssueVoucherPage));
